import { TypeComplaint } from "./type-complaints.model";
import { Sale, SaleForm } from "./sales.model";
import { User } from "./users.model";
import { Tiers } from "./tiers.model";

export class ComplaintImage {
  id: number;
  name: string;
  path: string;
  createAt: Date;
}

export class Complaint extends Sale {
  quantity: number;
  comment: string;
  numeroRc: string;
  emetteur: User;
  processusService: string;
  codeClient: string;
  segmentClient: string;
  dateProduction: Date;
  dateLivraison: Date;
  motifCategory: string;
  motifRc: string;
  maitreOuvrage: Tiers;
  laboExterne: Tiers;
  typeComplaint: TypeComplaint;
  images: ComplaintImage[];

  constructor() {
    super();
    this.typeComplaint = new TypeComplaint();
    this.emetteur = new User();
    this.maitreOuvrage = new Tiers();
    this.laboExterne = new Tiers();
    this.images = [];
  }
}

export class ComplaintForm extends SaleForm {
  quantity: number;
  comment: string;
  numeroRc: string;
  emetteur: number;
  processusService: string;
  codeClient: string;
  segmentClient: string;
  dateProduction: Date;
  dateLivraison: Date;
  motifCategory: string;
  motifRc: string;
  maitreOuvrage: number;
  laboExterne: number;
  typeComplaint: number;

  constructor() {
    super();
  }
}
